export const hostbuddyApiBaseUrl =
  import.meta.env.VITE_HOSTBUDDY_API_BASE_URL ||
  'https://dev4-dot-select-stays-chatbot-v02.appspot.com';

export const hostbuddyApiKey = import.meta.env.VITE_HOSTBUDDY_API_KEY;
